<template>
  <div>
    <h3>Besichtigungstermin vereinbaren</h3>

    <h4>Ihre Daten</h4>

    <div class="form-row">

      <div class="form-group col-md-6">
        <label class="form-label" for="firstname">Vorname:</label>
        <input type="text" v-model="formData.firstname" class="form-control" id="firstname" name="firstname">
      </div>

      <div class="form-group col-md-6">
        <label class="form-label" for="lastname">Name<span class="text-danger">*</span>:</label>
        <input type="text" v-model="formData.lastname" class="form-control" id="lastname" name="lastname">
        <div class="invalid-feedback d-block" v-if="formerrors.includes('lastname')">
          Bitte geben Sie Ihren Namen an.
        </div>
      </div>

    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label class="form-label" for="mobile">Mobilnummer<span class="text-danger">*</span>:</label>
        <vue-tel-input
            v-model="formData.mobile"
            :preferred-countries="['de', 'at', 'ch']"
            :default-country="'de'"
            placeholder="Mobilnummer eingeben"
            :input-options="{
              id: 'mobile',
              name: 'mobile',
              class: 'form-control'
            }"
            @validate="onPhoneValidate"
            @input="onPhoneInput"
            mode="international"
            :auto-format="true"
            :format-on-display="true"
            :include-country-code="true"
        ></vue-tel-input>
        <div class="invalid-feedback d-block" v-if="formerrors.includes('mobile')">
          Bitte geben Sie eine gültige Mobilnummer an.
        </div>
      </div>

      <div class="form-group col-md-6">
        <label class="form-label" for="email">E-Mail:</label>
        <input type="email" v-model="formData.email" class="form-control" id="email" name="email">
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label class="form-label" for="licenseplate">Kennzeichen<span class="text-danger">*</span>:</label>
        <input type="text" v-model="formData.licenseplate" class="form-control" id="licenseplate" name="licenseplate">
        <div class="invalid-feedback d-block" v-if="formerrors.includes('licenseplate')">
          Bitte geben Sie Ihr Kennzeichen an.
        </div>
      </div>

      <div class="form-group col-md-6">
        <label class="form-label" for="manufacturer">Hersteller<span class="text-danger">*</span>:</label>
        <input type="text" v-model="formData.manufacturer" class="form-control" id="manufacturer" name="manufacturer">
        <div class="invalid-feedback d-block" v-if="formerrors.includes('manufacturer')">
          Bitte geben Sie den Hersteller an.
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label class="form-label" for="model">Modell:</label>
        <input type="text" v-model="formData.model" class="form-control" id="model" name="model">
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-12">
        <label class="form-label" for="description">Schadenbeschreibung<span class="text-danger">*</span>:</label>
        <textarea name="description" v-model="formData.description" class="form-control" id="description"></textarea>
        <p class="small text-muted" v-if="!formerrors.includes('description')">Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.</p>
        <div class="invalid-feedback d-block" v-if="formerrors.includes('description')">
          Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="Schadenbilder">Schadenbilder (JPG, PNG) - optional:</label>
      <vue-dropzone
          ref="myVueDropzone1"
          :useCustomSlot="true"
          id="dropzone"
          @vdropzone-upload-progress="uploadProgress"
          :options="dropzoneOptions"
          @vdropzone-file-added="fileAdded"
          @vdropzone-sending-multiple="sendingFiles"
          @vdropzone-success-multiple="success"
      ><div class="dz-message" data-dz-message><span>Dateien mit Drag & Drop hochladen oder Foto machen</span></div></vue-dropzone>
      <AttachmentList
          :tempAttachments="getTempAttachments"
          :attachments="getAttachments"
      />
    </div>

    <div class="form-group">
      <label class="form-label" for="infos">Wie und wann können wir Sie für Rückfragen erreichen<span class="text-danger">*</span>:</label>
      <textarea name="infos" v-model="formData.infos" class="form-control" id="infos"></textarea>
      <div class="invalid-feedback d-block" v-if="formerrors.includes('infos')">
        Bitte geben Sie Infos für evtl. Rückfragen an.
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-12">
        <div class="d-flex justify-content-between">
          <button class="btn btn-secondary my-3 mr-2" @click="goBack()">Zurück</button>
          <button class="btn btn-primary my-3" @click="onSubmitAppointment()" :disabled="isSubmitting || showPhoneVerificationBox">
            <span v-if="isSubmitting">Wird gesendet...</span>
            <span v-else>Termin buchen</span>
          </button>
        </div>
      </div>
    </div>

    <div class="mt-2 text-danger"><small>* = Erforderlich</small></div>

    <div v-if="showPhoneVerificationBox && !waitForBookingConfirmation">
      <KSRPhoneVerification @verficationStatus="onVerficationStatus"></KSRPhoneVerification>
      <!-- Error message -->
      <div v-if="verificationError" class="alert alert-danger mt-3">
        {{ verificationError }}
      </div>
    </div>

    <div v-if="waitForBookingConfirmation" class="loading-container">
      <div class="spinner"></div>
      <p class="loading-text">Bitte warten...</p>
    </div>

    <!-- Error message -->
    <div v-if="apiError" class="alert alert-danger mt-3">
      {{ apiError }}
    </div>

  </div>
</template>

<script>
import KSRPhoneVerification from "./KSRPhoneVerification.vue";
import AttachmentList from "./AttachmentList.vue";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: 'KSRViewingAppointmentForm',
  components: {AttachmentList, KSRPhoneVerification, vueDropzone: vue2Dropzone},
  data() {
    return {
      studioId: false,
      formData: {
        lastname: '',
        firstname: '',
        mobile: '',
        email: '',
        licenseplate: '',
        manufacturer: '',
        model: '',
        description: '',
        infos: ''
      },
      formerrors: [],
      isSubmitting: false,
      apiError: '',
      isPhoneValid: false,
      phoneObject: null,
      // Data from localStorage
      selectedSlotStart: '',
      selectedEmployeeId: '',
      typeDetails: {},
      insuranceData: {},
      showPhoneVerificationBox: false,
      verificationError: false,
      waitForBookingConfirmation: false,
      tempAttachments: [],
      attachments: [],
      filesAdded: [],
      dropzoneOptions: {
        url: '/api/ksr/upload/damages/temp',
        //autoProcessQueue: false,
        maxFilesize: 10000000,
        headers: {
          //Authorization: ``
        },
        paramName: function(n) {
          return "file[]";
        },
        dictDefaultMessage: "Dateien hier ablegen",
        includeStyling: false,
        previewsContainer: false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: true,
        parallelUploads: 5,
        createImageThumbnails: true,
        maxThumbnailFilesize: 10,
        acceptedFiles: 'image/*,application/pdf', // needed for IOS/Android to show both camera and filebrowser
        init: function() {
          // Still enforce image-only validation
          this.on("addedfile", function(file) {
            if (!file.type.match(/^image\//)) {
              this.removeFile(file);
              alert("Nur Bilddateien sind erlaubt!");
            }
          });
        }
      }
    }
  },
  created() {
    this.studioId = this.$parent.studioId;
    // Load data from localStorage when component is created
    this.loadFromLocalStorage();
  },
  computed: {
    getTempAttachments() {
      return this.tempAttachments;
    },
    getAttachments() {
      return this.attachments;
    }
  },
  methods: {
    loadFromLocalStorage() {
      try {
        // Load existing data to include in submission
        this.selectedSlotStart = localStorage.getItem('selectedSlotStart') || '';
        this.selectedEmployeeId = localStorage.getItem('selectedEmployeeId') || '';

        const storedLicensePlate = localStorage.getItem('licensePlate') || '';
        if (storedLicensePlate && storedLicensePlate !== 'k') {
          this.formData.licenseplate = storedLicensePlate;
        }

        const storedTypeDetails = localStorage.getItem('typeDetails');
        if (storedTypeDetails) {
          this.typeDetails = JSON.parse(storedTypeDetails);
          if (this.typeDetails.manufacturer) {
            this.formData.manufacturer = this.typeDetails.manufacturer;
          }
          if (this.typeDetails.model) {
            this.formData.model = this.typeDetails.model;
          }
        }

        const storedInsuranceData = localStorage.getItem('insuranceData');
        if (storedInsuranceData) {
          this.insuranceData = JSON.parse(storedInsuranceData);
        }
      } catch (error) {
        console.error('Error loading from localStorage:', error);
      }
    },
    async onSubmitAppointment() {
      // Clear previous errors
      this.formerrors = [];
      this.apiError = '';

      // Validate required fields
      if (this.formData.lastname === '') {
        this.formerrors.push('lastname');
      }
      if (this.formData.mobile === '' || !this.isPhoneValid) {
        this.formerrors.push('mobile');
      }
      if (this.formData.licenseplate === '') {
        this.formerrors.push('licenseplate');
      }
      if (this.formData.manufacturer === '') {
        this.formerrors.push('manufacturer');
      }

      // If there are validation errors, don't proceed
      if (this.formerrors.length > 0) {
        return;
      }

      // Submit to API
      this.isSubmitting = true;

      try {
        const appointmentData = {
          ...this.formData,
          selectedSlotStart: this.selectedSlotStart,
          typeDetails: this.typeDetails,
          insuranceData: this.insuranceData,
          store_id: this.studioId
        };

        const response = await fetch('/api/appointment/send-verification', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify(appointmentData)
        });

        const data = await response.json();

        if (response.ok) {
          // Success - store verification token and navigate to verification
          localStorage.setItem('verificationToken', data.verification_token);
          //localStorage.setItem('appointmentData', JSON.stringify(appointmentData));

          this.showPhoneVerificationBox = true;

          // Navigate to phone verification
          //this.$router.push('/phone-verification');
          /*if (this.$router) {
            this.$router.push('/phone-verification');
          } else {
            window.location.hash = '#/phone-verification';
          }*/
        } else {
          // Handle API errors
          this.apiError = data.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.';
        }
      } catch (error) {
        console.error('API Error:', error);
        this.apiError = 'Verbindungsfehler. Bitte prüfen Sie Ihre Internetverbindung.';
      } finally {
        this.isSubmitting = false;
      }
    },
    goBack() {
      // Go back using hash navigation
      window.history.back();
    },
    onPhoneValidate(phoneObject) {
      console.log('Phone validation:', phoneObject);
      this.isPhoneValid = phoneObject.valid;
      this.phoneObject = phoneObject;
    },
    onPhoneInput(formattedNumber, phoneObject) {
      console.log('Phone input - Formatted:', formattedNumber);
      console.log('Phone input - Object:', phoneObject);

      // Store the formatted international number if valid
      if (phoneObject && phoneObject.valid) {
        this.formData.mobile = phoneObject.formatInternational || formattedNumber;
        this.isPhoneValid = true;
        this.phoneObject = phoneObject;
      } else {
        // Keep the current input but mark as invalid
        this.formData.mobile = formattedNumber;
        this.isPhoneValid = false;
      }
    },
    fileAdded(file) {
      // Construct your file object to render in the UI
      let attachment = {};
      attachment._id = file.upload.uuid;
      attachment.title = file.name;
      attachment.type = "file";
      attachment.extension = "." + file.type.split("/")[1];
      attachment.content = "File Upload by Select or Drop";
      attachment.thumb = file.dataURL;
      attachment.thumb_list = file.dataURL;
      attachment.isLoading = true;
      attachment.progress = null;
      attachment.size = file.size;
      this.tempAttachments = [...this.tempAttachments, attachment];
    },
    sendingFiles(files, xhr, formData) {
      let uuids = [];
      for(var k = 0; k < files.length; k++) {
        uuids.push(files[k].upload.uuid);
      }
      formData.append('uuids', uuids);
      formData.append('type', 'viewing-appointment');
    },
    // function where we get the upload progress
    uploadProgress(file, progress, bytesSent) {
      this.tempAttachments.map(attachment => {
        if (attachment.title === file.name) {
          attachment.progress = `${Math.floor(progress)}`;
        }
      });
    },
    // called on successful upload of a file
    success(file, response) {
      for(var i = 0; i < file.length; i++) {
        for(var k = 0; k < this.tempAttachments.length; k++) {
          if(this.tempAttachments[k]._id == file[i].upload.uuid) {
            //console.log("update");
            this.tempAttachments[k].title = response[i];
            this.tempAttachments[k].thumb = file[i].dataURL;
            this.tempAttachments[k].thumb_list = file[i].dataURL;
          }
        }
      }
    },
    async onVerficationStatus(payload) {
      console.log(payload);

      if(payload.message == 'success') {
        // Only show loading spinner for successful verification
        this.waitForBookingConfirmation = true;

        const appointmentData = {
          formdata: this.formData,
          selectedSlotStart: this.selectedSlotStart,
          employeeId: this.selectedEmployeeId,
          typeDetails: this.typeDetails,
          insuranceData: this.insuranceData,
          tempAttachments: this.tempAttachments
        };

        console.log(appointmentData);

        try {
          const response = await fetch(`/api/ksr/${this.studioId}/guest-viewing-appointment/confirm`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify(appointmentData)
          });

          const result = await response.json();

          console.log(result);

          this.waitForBookingConfirmation = false;

          if (response.ok) {
            console.log('Appointment confirmed successfully:', result);
            this.$router.push('/thank-you');
          } else {
            console.error('Error confirming appointment:', result);
            this.apiError = result.message || 'An error occurred while confirming the appointment. Please try again.';
          }
        } catch (error) {
          console.error('Network Error:', error);
          this.apiError = 'Connection error. Please check your internet connection.';
          this.waitForBookingConfirmation = false;
        }
      }
      else {
        // Verification failed - show error message, don't show loading spinner
        this.verificationError = payload.message;
        // Make sure loading spinner is hidden
        this.waitForBookingConfirmation = false;
      }
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.vue-tel-input {
  height: 50px;
  border: 1px solid #dee2e6;
}
 .loading-container {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 3rem 1rem;
   min-height: 200px;
 }

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
  text-align: center;
}
</style>
